// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__TLIbZ","title":"InfoRow_title__1XMjA"};